export default __webpack_public_path__ + "static/media/@_carinereis.285238d0.jpg";